export default "__VITE_ASSET__aBG90PHE__"